var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-elevation-7"},[_c('md-card-header',{staticClass:"md-elevation-5",attrs:{"data-background-color":_vm.dataBackgroundColor}},[_vm._t("header")],2),_vm._v(" "),_c('md-card-content',[_vm._t("content")],2),_vm._v(" "),_c('md-card-actions',{staticClass:"footer",attrs:{"md-alignment":"left"}},[_vm._t("footer")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c64ae5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatsCard.vue
// module id = null
// module chunks = 